/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Drop_HintInputs */

const en_story_drop_hint = /** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop photo or video`)
};

const es_story_drop_hint = /** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suelta foto o video`)
};

const fr_story_drop_hint = /** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déposez une photo ou vidéo`)
};

const de_story_drop_hint = /** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto oder Video hier ablegen`)
};

const id_story_drop_hint = /** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarik foto atau video`)
};

/** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */
const ja_story_drop_hint = en_story_drop_hint;

/** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */
const zh_story_drop_hint = en_story_drop_hint;

/** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */
const ar_story_drop_hint = en_story_drop_hint;

/** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */
const it_story_drop_hint = en_story_drop_hint;

/** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */
const ru_story_drop_hint = en_story_drop_hint;

/** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */
const pt_story_drop_hint = en_story_drop_hint;

/** @type {(inputs: Story_Drop_HintInputs) => LocalizedString} */
const ko_story_drop_hint = en_story_drop_hint;

/**
* | output |
* | --- |
* | "Drop photo or video" |
*
* @param {Story_Drop_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_drop_hint = /** @type {((inputs?: Story_Drop_HintInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Drop_HintInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_drop_hint(inputs)
	if (locale === "es") return es_story_drop_hint(inputs)
	if (locale === "fr") return fr_story_drop_hint(inputs)
	if (locale === "de") return de_story_drop_hint(inputs)
	if (locale === "ja") return ja_story_drop_hint(inputs)
	if (locale === "zh") return zh_story_drop_hint(inputs)
	if (locale === "ar") return ar_story_drop_hint(inputs)
	if (locale === "id") return id_story_drop_hint(inputs)
	if (locale === "it") return it_story_drop_hint(inputs)
	if (locale === "ru") return ru_story_drop_hint(inputs)
	if (locale === "pt") return pt_story_drop_hint(inputs)
	return ko_story_drop_hint(inputs)
});